var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { first } from 'lodash';
import { SliceHeader } from './slice-header';
import { classNames } from '../../utils/cn';
import { ContentEntityIntro } from './content-entity-intro';
import { ContentEntityContent } from './content-entity-content';
import { entityColorInfo } from '../../utils/entity-color-info';
import { useImage } from '../../hooks/use-image';
var cls = classNames('slice-featured-organisation');
export var SliceFeaturedOrganisationDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: 1em;\n  "], ["\n    font-size: 1em;\n  "])))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme.UNIT(10))
});
var LogoStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    img { \n      width: 280px;\n    }\n  "], ["\n    img { \n      width: 280px;\n    }\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: ", " 0;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: ", " 0;\n  "])), theme.UNIT(6)),
  tablet: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding: ", " 0;\n  "], ["\n    padding: ", " 0;\n  "])), theme.UNIT(12))
});
var ContentStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: 1em;\n    color: inherit;\n    text-align: center;\n    padding: ", ";\n    \n  "], ["\n    font-size: 1em;\n    color: inherit;\n    text-align: center;\n    padding: ", ";\n    \n  "])), theme.UNIT(4))
});
var IntroStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    color: inherit;\n    font-weight: 400;\n    margin-top: ", ";\n    margin-bottom: ", ";\n    padding-bottom: ", ";\n    align-self: stretch;\n    text-align: center;\n    \n    ", "\n  "], ["\n    color: inherit;\n    font-weight: 400;\n    margin-top: ", ";\n    margin-bottom: ", ";\n    padding-bottom: ", ";\n    align-self: stretch;\n    text-align: center;\n    \n    ", "\n  "])), theme.UNIT(6), theme.UNIT(8), theme.UNIT(8), function (props) {
    return css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), theme.H_DOT_BG_END(props.color, 2, 6));
  })
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: styled(SliceHeader)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Logo: styled.div.attrs(cls.attr('logo'))(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), LogoStyles),
  Intro: styled(ContentEntityIntro)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), IntroStyles),
  Content: styled(ContentEntityContent)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles)
};
export var SliceFeaturedOrganisation = function SliceFeaturedOrganisation(props) {
  var className = props.className,
      entity = props.entity;
  var Image = useImage();
  var organisation = first(entity.organisations);

  var _a = entityColorInfo(entity, props),
      color = _a.color,
      isInverted = _a.isInverted;

  var logo = organisation && (isInverted ? organisation.logoInverted || organisation.logo : organisation.logo);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Header, {
    borderColor: 'light',
    entity: entity
  }), React.createElement(My.Body, null, logo && React.createElement(My.Logo, null, React.createElement(Image, {
    image: logo
  })), React.createElement(My.Intro, {
    _color: color,
    entity: entity
  }), React.createElement(My.Content, {
    entity: entity
  })));
};
SliceFeaturedOrganisation.defaultProps = SliceFeaturedOrganisationDefaultProps;
SliceFeaturedOrganisation.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;